import {
  createComponentExtension,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { techRadarPlugin } from '@backstage-community/plugin-tech-radar';
import { rootRouteRef } from './routes';

export const TechRadarPage = techRadarPlugin.provide(
  createRoutableExtension({
    name: 'CustomTechRadarPage',
    component: () =>
      import('./components/TechRadarPage').then(m => m.TechRadarPage),
    mountPoint: rootRouteRef,
  }),
);

export const HomePageCard = techRadarPlugin.provide(
  createComponentExtension({
    name: 'HomePageCard',
    component: {
      lazy: () => import('./components/HomePageCard').then(m => m.HomePageCard),
    },
  }),
);
